export default __webpack_public_path__ + "img/d823af934da1bfdecf4f4ae495ea3222.svg";